import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import List from "../../List/List"
import UserBuilderErrors from "../UserBuilderErrors"

export default class UserBuilderRoles extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.role_name || null
    }
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(){
    if(this.props.role_name != this.state.role && !this.props.revert) {
      this.setState({
        role: this.props.role_name
      })
    }
  }

  render() {

    var tabClasses = clsx({
      'active': this.props.active_tab == 'roles',
      'tab-pane': true
    });
    var roles = [this.props.role]
    if (this.props.active_tab == 'roles' && (this.props.read_only || this.props.modifying_self || this.props.owner)) {
      return (
        <div className={tabClasses} id ="roles">
         { roles.length && roles != "none" ?
          <List
          header_primary="name"
          items={roles}
          display_column_primary="name"
          none_selected={roles[0] == "none"} />
          :
          <div className="no-records">
            <span className="none">{I18n.t('none')}</span>
          </div>}
        </div>
      )
    }
    else if (this.props.active_tab == 'roles') {
      return (
        <div className={tabClasses} id="roles">

          {this.renderErrors()}

          {/* {this.renderPrintButton()} */}

          {this.props.modifying_self ? <div className="alert alert-warning text-center"><strong>{I18n.t('users_cannot_edit_their_own_role')}</strong></div> : null}

          {this.props.owner && !this.props.modifying_self ? <div className="alert alert-warning text-center"><strong>{I18n.t('the_owner_user_cannot_be_modified')}</strong></div> : null}

          <div className="row">
            <div className="col-md-12">
              <div className="select-all-none" id="selected_rooms" style={{ marginBottom: 4 }}>
                <div className="item">
                  <label>
                    {/* <input
                      type="radio"
                      checked={(this.props.role_name == 'none' && !this.state.role) || this.state.role == 'none' ? true : false}
                      value={'none'}
                      onChange={this.onChange}
                      name="role"
                    /> */}
                    {/* <em>None</em> */}
                    <b>{`${I18n.t('roles')}*`}</b>
                  </label>
                </div>
                <hr />
                {this.renderForm(this.props.role_names)}
              </div>
            </div>
          </div>

        </div>
      );
    } else {
      return null
    }
  }

  renderForm(inputs) {
    var self = this
    var rendered_inputs = inputs.map((input, idx) => self.renderInput(input, idx))
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="items">
            {rendered_inputs}
          </div>
        </div>
      </div>
    )
  }

  renderInput(input, idx) {
    return (
      <div className="item" key={idx}>
        <label>
          <input
            type="radio"
            value={input}
            checked={this.isSelected(input)}
            onChange={this.onChange}
            name="role"
            disabled={input == 'MAX Admin'}
          />
          {this.buildRadioLabel(input)}
        </label>
      </div>
    )
  }
  buildRadioLabel(input) {
    var label = input
    return label
  }

  isSelected(id) {
    if (id === this.state.role) return true
    else if (id === this.props.role_name && (!this.state.role)) return true
    return false
  }

  renderErrors() {
    var errors = UserBuilderErrors.roles(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  onChange(event) {

    this.setState({
      role: event.target.value
    })
    this.props.onChangeRoleName(event)
  }

}
